import { Link } from "react-router-dom";
import React from "react";
import styled from "styled-components";

const RecipeItem = ({ item }) => (
  <StyledItem className={"no-select"}>
    <Link to={item.button_link}>
      <div className={"img-wrapper"}>
        <img src={item.image} alt={""} />
      </div>
    </Link>
  </StyledItem>
);

const StyledItem = styled.div`
  position: relative;
  height: 100%;
  color: white;

  .img-wrapper {
    overflow: hidden;
    border-radius: 8px;

    img {
      object-fit: contain;
      width: 100%;
      height: auto;
      border-radius: 8px;
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.05);
      }
    }
  }
`;

export default RecipeItem;
